import { getAxiosClient } from "@/services/HttpsService";
import {
  setPageNumber,
  setRowsPerpage,
} from "../../services/state/monitor/monitor";
import { AppDispatch, RootState } from "@/services/state/store";
import { useToast, Text } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchProcessInstances } from "../../services/state/monitor/monitor-async-calls";
import { formatTableDate } from "../../utils/dateFormatter";

type CheckboxesType = {
  active: boolean;
  inProgress: boolean;
  completed: boolean;
};

export const useMonitor = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const toast = useToast();

  const [search, setSearch] = useState("");
  const [checkboxes, setCheckboxes] = useState<CheckboxesType>({
    active: false,
    inProgress: false,
    completed: false,
  });
  const [startedBy, setStartedBy] = useState("");
  const [timeRange, setTimeRange] = useState("time-30d");
  const [processCreatedBy, setProcessCreatedBy] = useState("");

  const pageNumber = useSelector(
    (state: RootState) => state.monitor.monitorPageNumber
  );
  const rowsPerPage = useSelector(
    (state: RootState) => state.monitor.rowsPerPage
  );
  const totalPages = useSelector(
    (state: RootState) => state.monitor.totalPages
  );

  const processInstances = useSelector(
    (state: RootState) => state.monitor.processIntances || []
  );

  const fetchFilteredData = (page: number, size: number) => {
    console.log("page", page, "size", size);
    dispatch(setPageNumber(page));
    dispatch(setRowsPerpage(size));

    const filters = {
      search,
      status: Object.entries(checkboxes)
        .filter(([_, value]) => value)
        .map(([key]) => key), // Convert selected checkboxes to API expected format
      startedBy,
      timeRange,
      processCreatedBy,
    };

    dispatch(
      fetchProcessInstances({
        monitorPageNumber: page,
        rowsPerPage: size,
        filters,
      })
    );
  };

  const handleFilterChange = (filters: {
    search?: string;
    checkboxes?: CheckboxesType;
    startedBy?: string;
    timeRange?: string;
    processCreatedBy?: string;
  }) => {
    setSearch((prev) => filters.search ?? prev);
    setCheckboxes((prev) => filters.checkboxes ?? prev);
    setStartedBy((prev) => filters.startedBy ?? prev);
    setTimeRange((prev) => filters.timeRange ?? prev);
    setProcessCreatedBy((prev) => filters.processCreatedBy ?? prev);

    // fetchFilteredData(pageNumber, rowsPerPage);
  };

  const handlePageChange = (page: number, size: number) => {
    console.log("handlePageChange page", page, "size", size);
    fetchFilteredData(page, size);
  };

  useEffect(() => {
    fetchFilteredData(pageNumber, rowsPerPage);
  }, [search, checkboxes, startedBy, timeRange, processCreatedBy]);

  const columns = [
    {
      Header: "Process Name",
      accessor: "processName",
    },
    {
      Header: "Process Model",
      accessor: "processModel",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Started By",
      accessor: "startedBy",
    },
    {
      Header: "Start Time",
      accessor: "startTime",
    },
    {
      Header: "End Time",
      accessor: "endTime",
    },
  ];

  const columnData = processInstances.map((pi) => {
    return {
      processName: (
        <Text
          onClick={() =>
            window.open(
              `/platform/design/process-instance/${pi.processUuid}/${pi.processInstanceUuid}`,
              "_blank" // Ensures it opens in a new tab or window
            )
          }
          color="brand.500"
          cursor="pointer"
          _hover={{
            color: "brand.700",
            textDecoration: "underline",
          }}
          transition="all 0.2s ease"
          fontWeight="semibold"
          textUnderlineOffset="2px"
        >
          {pi.processDisplayName}
        </Text>
      ),
      status: pi.instanceStatus,
      processModel: pi.processName,
      startedBy: pi.instanceCreatedBy,
      startTime: pi.instanceCreatedOn
        ? formatTableDate(new Date(pi.instanceCreatedOn))
        : "-",
      endTime: pi.instanceUpdatedOn
        ? formatTableDate(new Date(pi.instanceUpdatedOn))
        : "-",
    };
  });

  return {
    columns,
    columnData,
    rowsPerPage,
    totalPages,
    handleFilterChange,
    handlePageChange,
    search,
    checkboxes,
    startedBy,
    timeRange,
    processCreatedBy,
  };
};
